export enum LineOfBusinessId {
  Annuity = 1,
  LongTermCare = 2,
  Disability = 3,
  Life = 4,
}